import _toConsumableArray from "/drone/src/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/drone/src/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "/drone/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["enableExpandableSections", "renderExpandableSection", "expandableSectionControllerColumnId", "expandedSectionIds", "defaultExpandedSectionIds", "onSectionExpansionChange"];
import { useCallback, useMemo, useState } from 'react';
export var renderExpandableSectionEmpty = function renderExpandableSectionEmpty(data) {
  return '';
};
export var renderExpandableTriggerEmpty = function renderExpandableTriggerEmpty(data) {
  return undefined;
};
export var useDataTableExpandableSections = function useDataTableExpandableSections(columnsSafe, _ref) {
  var enableExpandableSections = _ref.enableExpandableSections,
      renderExpandableSection = _ref.renderExpandableSection,
      expandableSectionControllerColumnId = _ref.expandableSectionControllerColumnId,
      expandedSectionIds = _ref.expandedSectionIds,
      defaultExpandedSectionIds = _ref.defaultExpandedSectionIds,
      onSectionExpansionChange = _ref.onSectionExpansionChange,
      restProps = _objectWithoutProperties(_ref, _excluded);

  var expandableSectionControllers = useMemo(function () {
    var controllers = {};

    if (expandableSectionControllerColumnId) {
      controllers[expandableSectionControllerColumnId] = true;
    }

    columnsSafe.forEach(function (column) {
      if (column.expandableSectionController) {
        controllers[column.id] = true;
      }
    });

    if (enableExpandableSections !== undefined && !controllers.length && columnsSafe.length) {
      controllers[columnsSafe[0].id] = true;
    }

    return controllers;
  }, [columnsSafe, expandableSectionControllerColumnId, enableExpandableSections]);
  var reallyEnableExpandableSections = false;

  if (enableExpandableSections === undefined) {
    reallyEnableExpandableSections = !!renderExpandableSection && !!Object.keys(expandableSectionControllers).length;
  } else {
    reallyEnableExpandableSections = enableExpandableSections;
  }

  var _useState = useState(defaultExpandedSectionIds || []),
      _useState2 = _slicedToArray(_useState, 2),
      expandedSectionIdsInternal = _useState2[0],
      setExpandedSectionIdsInternal = _useState2[1];

  var expandedSectionIdsActual = expandedSectionIds || expandedSectionIdsInternal;
  var onExpansionChangeInternal = useCallback(function (expansion) {
    if (!expandedSectionIds) {
      setExpandedSectionIdsInternal(expansion);
    }

    if (onSectionExpansionChange) {
      onSectionExpansionChange(expansion);
    }
  }, [onSectionExpansionChange, expandedSectionIds]);
  var onExpansionSectionControllerTriggerClick = useCallback(function (event) {
    if (!reallyEnableExpandableSections) {
      return;
    }

    var rowId = event.currentTarget.getAttribute('data-rowid');

    if (!rowId) {
      return;
    }

    var expanded = expandedSectionIdsActual.includes(rowId);
    onExpansionChangeInternal(expanded ? expandedSectionIdsActual.filter(function (id) {
      return id !== rowId;
    }) : [rowId].concat(_toConsumableArray(expandedSectionIdsActual)));
  }, [expandedSectionIdsActual, onExpansionChangeInternal, reallyEnableExpandableSections]);
  return {
    result: {
      enableExpandableSections: reallyEnableExpandableSections,
      renderExpandableSection: renderExpandableSection || renderExpandableSectionEmpty,
      expandableSectionControllers: expandableSectionControllers,
      expandedSectionIds: expandedSectionIdsActual,
      onExpansionSectionControllerTriggerClick: onExpansionSectionControllerTriggerClick
    },
    restProps: restProps
  };
};